import { createFileRoute, useParams } from '@tanstack/react-router'
import { WorkspaceGeneralSettings } from '@/features/workspaces/settings'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/general'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { orgId, workspaceId } = useParams({
    from: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/general',
  })

  return <WorkspaceGeneralSettings orgId={orgId} workspaceId={workspaceId} />
}
